import type { TermType } from "@/shared/types";

/**
 * リソース用S3バケット名（環境変数から取得）
 */
export const RESOURCE_S3_BUCKET = import.meta.env.VITE_TERMS_BUCKET_NAME;

/**
 * リソース用S3バケットのベースURL
 */
export const RESOURCE_S3_BASE_URL = `https://${RESOURCE_S3_BUCKET}.s3.ap-northeast-1.amazonaws.com`;

/**
 * 利用規約のタイプ別パス
 */
export const TERM_PATHS: Record<TermType, string> = {
	app: "terms/app",
	glicomembers: "terms/glicomembers",
} as const;

/**
 * 利用規約ファイル名
 */
export const TERM_FILENAME = "term.html";

/**
 * バージョン履歴JSONファイル名
 */
export const TERMS_JSON_FILENAME = "terms.json";

/**
 * 利用規約のバージョン履歴JSON URLを生成
 * @param type - 規約タイプ ('app' | 'glicomembers')
 * @returns terms.json の URL
 */
export const getTermsJsonUrl = (type: TermType): string => {
	return `${RESOURCE_S3_BASE_URL}/${TERM_PATHS[type]}/${TERMS_JSON_FILENAME}`;
};

/**
 * 利用規約HTMLのS3 URLを生成
 * @param type - 規約タイプ ('app' | 'glicomembers')
 * @param version - バージョン (例: "v1", "v2")
 * @returns term.html の URL
 */
export const getTermHtmlUrl = (type: TermType, version: string): string => {
	return `${RESOURCE_S3_BASE_URL}/${TERM_PATHS[type]}/${version}/${TERM_FILENAME}`;
};

/**
 * 利用規約HTMLのS3キーを生成
 * @param type - 規約タイプ ('app' | 'glicomembers')
 * @param version - バージョン (例: "v1", "v2")
 * @returns S3キー
 */
export const getTermHtmlKey = (type: TermType, version: string): string => {
	return `${TERM_PATHS[type]}/${version}/${TERM_FILENAME}`;
};

/**
 * terms.jsonのS3キーを生成
 * @param type - 規約タイプ ('app' | 'glicomembers')
 * @returns S3キー
 */
export const getTermsJsonKey = (type: TermType): string => {
	return `${TERM_PATHS[type]}/${TERMS_JSON_FILENAME}`;
};

/**
 * S3 URI からキーを抽出
 * @param s3Uri - S3 URI (例: "s3://bucket-name/path/to/file.html")
 * @returns S3キー (例: "path/to/file.html")
 */
export const extractS3KeyFromUri = (s3Uri: string): string => {
	// s3://bucket-name/path/to/file.html → path/to/file.html
	const match = s3Uri.match(/^s3:\/\/[^/]+\/(.+)$/);
	if (!match) {
		throw new Error(`Invalid S3 URI: ${s3Uri}`);
	}
	return match[1];
};
